module.exports = __webpack_public_path__ + "img/5.450181a1.png";